export default __webpack_public_path__ + "static/media/toogle-icon.b842c5e2.svg";